import { CircleAlert } from 'lucide-react';
import { t } from '../../i18n';
import { Button } from '../primitives/button';

type ErrorStateProps = {
  message?: string;
  onRetry: () => void;
  retrying?: boolean;
  labels?: { retry?: string; message?: string };
};

// A failed read: the mapped message and a retry (UI architecture §4). labels replace the catalog's texts for an app
// whose chrome is not Turkish; a given message still wins over labels.message.
export function ErrorState({ message, onRetry, retrying = false, labels }: ErrorStateProps) {
  return (
    <div role="alert" className="flex flex-col items-center gap-4 p-8 text-center">
      <CircleAlert aria-hidden className="size-(--icon-lg) text-danger" />
      <p className="text-sm">{message ?? labels?.message ?? t('components.ErrorState.message')}</p>
      <Button onClick={onRetry} disabled={retrying} aria-busy={retrying}>
        {labels?.retry ?? t('components.ErrorState.retry')}
      </Button>
    </div>
  );
}
